import React, { lazy } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { CssBaseline, Toolbar } from '@material-ui/core';
import clsx from 'clsx';
import ls from 'local-storage';
import api from '../lib/api';
import { updateUser, handleLoggedIn } from '../redux/auth/actions';
import i18n from '../i18n';

const CanvasLeftbar = lazy(() => import('./Canvas/CanvasLeftbar'));
const TopBar = lazy(() => import('./TopBar'));
const PromiseTopBar = lazy(() => import('./PromiseTopBar'));
const SimpleTopBar = lazy(() => import('./SimpleTopBar'));
const LeftSideBar = lazy(() => import('./LeftSideBar'));
const PromiseBottomBar = lazy(() => import('./PromiseBottomBar'));
const NotificationBar = lazy(() => import('./NotificationBar'));

const useStyles = (theme) => ({
    rootBody: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#f7f7f8',
    },
    root: {
        display: 'flex',
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#f7f7f8',
        [theme.breakpoints.up('lg')]: {
            width: '100%',
        },
        [theme.breakpoints.up('md')]: {
            width: '100%',
        },
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(0),
        [theme.breakpoints.up('sm')]: {
            // padding: theme.spacing(3)
        },
    },
});

class DashboardFrame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLeftBar: false,
        };

        // store url pathname in local storage, so we can use it once sing-up/in is done.
        /* if (!ls.get('isLoggedIn')) {
            ls.set('redirectMe', window.location.pathname + window.location.search);
        } */
    }

    async componentDidMount() {
        const { classes } = this.props;
        if (ls.get('isLoggedIn')) {
            // just in case, need to delete redirectMe from local storage.
            // if(ls.get('redirectMe')){
            //     ls.remove('redirectMe');
            // }
            document.getElementById('root').className = classes.rootBody;
            try {
                const userData = await this.getUserInfo();
                i18n.changeLanguage(userData.lang);
                this.props.authSetUser(userData);
            } catch (e) {
                console.log(e);
            }
        }
    }

    onToggleLeftBar() {
        this.setState((prevState) => ({
            showLeftBar: !prevState.showLeftBar,
        }));
    }

    getUserInfo = () => {
        return new Promise((res) => {
            api.getCurrentUserInfo()
                .then((resp) => {
                    const userData = resp.data.data;
                    res(userData);
                })
                .catch(() => {
                    ls.set('isLoggedIn', null);
                    ls.set('refreshToken', null);
                    this.props.authUserLogin(false);
                    // this.forceUpdate();
                });
        });
    };

    render() {
        const {
            classes,
            content,
            isPromise,
            backFunc,
            promiseBottom,
            children,
            searchBar,
            showError,
            showSuccess,
            errMessage,
            signatureSelected,
            promiseSelected,
            user,
            isLeftBar,
            showTopbar,
            isFabric,
        } = this.props;
        const { showLeftBar } = this.state;

        if (!user) {
            return null;
        }

        return (
            <div className={clsx(classes.root)}>
                <CssBaseline />
                {!showTopbar ? (
                    <SimpleTopBar />
                ) : isPromise ? (
                    <PromiseTopBar
                        isToggle
                        toggle={() => this.onToggleLeftBar()}
                        back={backFunc}
                    />
                ) : (
                    <TopBar
                        toggle={() => this.onToggleLeftBar()}
                        searchBar={searchBar}
                        deleteSignature={this.props.deleteSignature}
                        signatureSelected={signatureSelected}
                        promiseSelected={promiseSelected}
                        viewPromiseLog={this.props.viewPromiseLog}
                        downloadPromise={this.props.downloadPromise}
                        archivePromise={this.props.archivePromise}
                        user={user}
                    />
                )}
                {isLeftBar && (
                    <LeftSideBar
                        showLeftBar={showLeftBar}
                        toggle={() => this.onToggleLeftBar()}
                        isPromise={isPromise}
                    />
                )}
                {isFabric && <CanvasLeftbar />}
                <main className={clsx(classes.content, this.props.className)}>
                    {showTopbar && <Toolbar />}
                    {content}
                    {children}
                    {promiseBottom && <Toolbar />}
                </main>
                {<NotificationBar />}
                {promiseBottom && <PromiseBottomBar />}
                {/* {isFabric && <CanvasRightToolbar/>} */}
            </div>
        );
    }
}

DashboardFrame.defaultProps = {
    isPromise: false,
    searchBar: false,
    promiseBottom: false,
    backFunc: () => {},
    signatureSelected: false,
    deleteSignature: () => {},
    promiseSelected: false,
    viewPromiseLog: '',
    isLeftBar: true,
    showTopbar: true,
    className: '',
    downloadPromise: () => {},
    archivePromise: () => {},
    isFabric: false,
};

DashboardFrame.propTypes = {
    // content: PropTypes.object,
    isPromise: PropTypes.bool,
    searchBar: PropTypes.bool,
    promiseBottom: PropTypes.bool,
    isLeftBar: PropTypes.bool,
    showTopbar: PropTypes.bool,
    className: PropTypes.string,
    backFunc: PropTypes.func,
    signatureSelected: PropTypes.bool,
    deleteSignature: PropTypes.func,
    promiseSelected: PropTypes.bool,
    viewPromiseLog: PropTypes.string,
    downloadPromise: PropTypes.func,
    archivePromise: PropTypes.func,
    isFabric: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
    authSetUser: (user) => dispatch(updateUser(user)),
    authUserLogin: (isLoggedIn) => dispatch(handleLoggedIn(isLoggedIn)),
});

export default withStyles(useStyles)(
    connect(mapStateToProps, mapDispatchToProps)(DashboardFrame),
);
